import React, { useRef, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// ANTD
import { AutoComplete, Tooltip, Tag } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
// API
import { getTourPointAddress } from 'app/API/autocomplete';

//
import { publish } from 'app/libs/core/PubSub';
import * as way from 'app/libs/core/PubSubWays';
import withTranslations from 'app/components/HOGs/withTranslations';
import { useActions } from 'app/components/Utility/hooks/useAction.hooks';
import {
  PlaceTypes,
  PlaceIconType,
} from '../../../../constants/place.constant';
import { stickToRoad } from '../../Map/map_contextmenu_utils';
import mapUtils from '../../../../libs/Utils/mapUtils';

import { getCustomId } from '../../../../libs/core/Unique';

const CODE_ESCAPE = 27;

const { Option } = AutoComplete;

const PlacePoint = (props) => {
  const { tr } = props;

  const { setTypeMouseCursor } = useActions();

  const mouseCursorIconType = useSelector(
    (store) => store.cssEffect.mouseCursorIconType
  );

  const refPoint = useRef(null);
  const isExistEscListener = useRef(false);
  const refAC = useRef(null);

  const [result, setResult] = useState([]);
  const [val, setVal] = useState('');

  const setPlaceAddress = (data) => {
    const { lat, lng } = data;

    mapUtils.getTourstartGeocoder({ lat, lng }, (e) => {
      const address = mapUtils.formateTourstartAddress(e.data);
      const saveAddress = (lat, lng) => {
        props.PlacePointGet({
          value: address,
          lat,
          lng,
        });
      };
      if (address) {
        stickToRoad(lat, lng, saveAddress);
      }
    });
  };

  const takeAddressByClickMap = () => {
    publish(way.PLACE_EDIT_GET_ADDRESS_FROM_MAP_ON, (e) => {
      setPlaceAddress(e.latlng);
      publish(way.PLACE_EDIT_GET_ADDRESS_FROM_MAP_OFF);
      setTypeMouseCursor('');
    });
  };

  useEffect(() => {
    const { data, fetched } = props.placesData;
    if (!props.edit && fetched && !data.address) {
      setPlaceAddress(data);
    }
  }, [props.placesData.data]);

  const changeCursorWrapperClassName = (pointType = null) => {
    if (pointType) {
      if (pointType !== mouseCursorIconType) {
        setTypeMouseCursor(`cursor_${pointType}`);
      }
    } else {
      setTypeMouseCursor('');
    }
  };

  useEffect(() => {
    const { category } = props.placesData;

    const { lat, lng } = props.placesData.data;

    const type = () => {
      return PlaceTypes[category].toLowerCase().replace(/\s+/g, '');
    };

    if (lat && lng) {
      publish(way.PLACE_MAP_CLEAN);
      publish(way.PLACE_POINT_CREATE, {
        point: {
          lat,
          lng,
          draggable: true,
          id: getCustomId(),
          iconType: type(),
        },
      });
    }
    if (props.edit && !props.placesData.data.address) {
      changeCursorWrapperClassName(type());
    }
    if (!props.placesData.data.address) {
      takeAddressByClickMap(tr);
    }
    setVal(props.placesData.data.address);
  }, [
    props.placesData.data.address,
    props.placesData.category,
    props.placesData.color,
    props.edit,
  ]);

  const prefix = (props) => {
    const { category, fetched } = props.placesData;
    return fetched ? (
      <img
        src={PlaceIconType[category]}
        alt="icon"
        style={{ maxWidth: 20, maxHeight: 25 }}
      />
    ) : null;
  };

  const suffix = (props) => {
    const { edit, placesData } = props;

    if (edit && placesData.data && placesData.data.address) {
      return (
        <span className="ant-input-suffix">
          <div className="suffix_point_list">
            <Tooltip title="Delete">
              <DeleteOutlined
                style={{
                  fontSize: 15,
                  position: 'relative',
                  left: 22,
                  top: -1,
                  color: '#aa2493',
                }}
                onClick={() => {
                  publish(way.PLACE_MAP_CLEAN);
                  setVal('');
                  props.PlacePointGet({ lat: '', lng: '', value: '' });
                }}
              />
            </Tooltip>
          </div>
        </span>
      );
    }

    return null;
  };

  const escFunction = (event) => {
    // eslint-disable-next-line no-use-before-define
    if (event.keyCode === CODE_ESCAPE) clearAutoProp();
  };

  const clearAutoProp = () => {
    const escFunction = (event) => {
      if (event.keyCode === CODE_ESCAPE) clearAutoProp();
    };
    document.removeEventListener('keydown', escFunction, false);
    setResult([]);
    isExistEscListener.current = false;
  };

  const handleSearch = (value) => {
    let result = [];

    if (value) {
      if (!isExistEscListener.current) {
        document.addEventListener('keydown', escFunction, false);
        isExistEscListener.current = true;
      }
      if (value.length > 1) {
        result = [
          {
            value: `${tr.Searching}...`,
            data: 555,
            disabled: true,
          },
        ];
        getTourPointAddress(value, setResult);
      }
      setResult(result);
    } else {
      clearAutoProp();
    }
  };

  const handleSelect = (index, el) => {
    const { lat, lng } = el.props.rel;
    if (lat && lng) {
      publish(way.PLACE_MAP_CLEAN);
      props.PlacePointGet({ lat, lng, value: el.props.children[0] });
      publish(way.PLACE_POINT_CREATE, {
        point: {
          lat,
          lng,
          draggable: false,
          id: getCustomId(),
          iconType: 'custom',
        },
      });
    }
    clearAutoProp();
  };

  const children = result.map((el, i) => {
    if (el && el.data) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        <Option key={el.value + i} rel={el.data} disabled={el.disabled}>
          {el.value}
          {el.tag ? <Tag>{el.tag.replace('_', ' ')}</Tag> : null}
        </Option>
      );
    }

    return null;
  });

  return (
    <div className="tourFullPoints">
      <div className="tourFullPointsScroll">
        <span
          className="ant-input-affix-wrapper"
          style={{ marginBottom: props.edit ? 0 : 6 }}
          ref={(link) => {
            refPoint.current = link;
          }}
          onMouseEnter={() => {
            refPoint.current.style.border = '1px solid #aa2493';
            refPoint.current.classList.value =
              'ant-input-affix-wrapper selectPoint';
          }}
          onMouseLeave={() => {
            refPoint.current.style.border = '1px solid transparent';
            refPoint.current.classList.value = 'ant-input-affix-wrapper';
          }}
        >
          <span
            className="ant-input-prefix"
            style={props.edit ? { justifyContent: 'flex-end' } : null}
          >
            {prefix(props)}
          </span>
          {!props.edit ? <div className="readOnlyInput" /> : null}
          {result.length === 1 && !result[0].data ? (
            <div
              className="no-address-found"
              onClick={() => {
                clearAutoProp();
              }}
              aria-hidden
            >
              {tr['No address found']}
            </div>
          ) : null}
          <AutoComplete
            ref={refAC}
            onSearch={handleSearch}
            onSelect={handleSelect}
            placeholder={tr['Write place address']}
            dropdownMatchSelectWidth={355}
            dropdownClassName="create_address_drop"
            style={{ width: '100%' }}
            value={val}
            onChange={(val) => setVal(val)}
          >
            {children}
          </AutoComplete>
          {suffix(props)}
        </span>
      </div>
    </div>
  );
};

export default withTranslations(PlacePoint);
